import style from './PetFriendly.module.scss';

const PetFriendly = () => {
  return (
    <section className={style.container}>
      <h1 className={style.titulo}>Lugares PetFriendly - Uberaba</h1>
      
      <main className={style.lista}>
        <ul>
          <h3>Hospedagem </h3>
          <li>Hotel Flor de Minas</li>
          <li>Uberaba Apart Hotel</li>
        </ul>

        <ul>
          <h3>Bares/Restaurantes</h3>
          <li>Tora Bar</li>
        </ul>

        <ul>
          <h3>Shopping</h3>
          <li>Shopping Uberaba</li>
        </ul>
      </main>

    </section>
  )
}

export default PetFriendly;